/*
 * TwoFive — Campo «Código de descuento» en el carrito lateral y en /cart (solo tienda B2C).
 *
 * Sustituye al campo que tenía el carrito de Section Store. Funciona siempre, con o sin campaña.
 *
 * Con Black November activo (snippets/bn-gift-config.liquid → #bn-gift-config) el regalo no es acumulable
 * con códigos, así que el cliente elige:
 *   · si hay guante de regalo en el carrito o ya ha llegado a una franja, antes de aplicar el código se le
 *     avisa y elige «Usar mi código (sin regalo)» o «Prefiero el regalo»;
 *   · al usar el código: se quita el regalo, se aplica el código y se comprueba que Shopify lo acepta;
 *     si el código no vale, se quita y se devuelve el mismo guante de regalo (misma variante);
 *   · al quitar el código, el bloque de Black November (assets/bn-gift.js) vuelve a ofrecer el regalo.
 *
 * Registro: cada código que el cliente prueba queda en el atributo de carrito «Código intentado», que Shopify
 * copia al pedido (Detalles adicionales), con su estado final: APLICADO, APLICADO Y QUITADO DESPUÉS,
 * ELIGIÓ EL REGALO (NO APLICADO), NO VÁLIDO (no existe, caducado o desactivado), NO APLICABLE (motivo) o
 * ENVÍO GRATIS (SE APLICA EN EL PAGO). Los códigos que se meten directamente en la página de pago no se registran.
 *
 * Motivo del rechazo: la API AJAX solo dice applicable:false. Para saber por qué, se repite la operación con la
 * Storefront API (cartDiscountCodesUpdate → warnings) sobre el mismo carrito, con el token público del canal
 * Headless (#tf-disc-config). Si falla, queda «NO APLICADO».
 *
 * Usa la API AJAX del carrito: /cart.js, /cart/update.js { discount, attributes }, /cart/change.js, /cart/add.js.
 * No modifica archivos del tema: inserta el campo en el DOM y lo vuelve a insertar cuando el tema repinta.
 * Se carga desde sections/twofive-card-grid.liquid solo si el cliente no es B2B.
 */
(function () {
  'use strict';
  if (window.__tfCartDiscount) return;
  window.__tfCartDiscount = true;
 
  var LOG = '[tf-discount]';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var doFetch = function () { return window.fetch.apply(window, arguments); };
 
  // ─── Black November (opcional) ──────────────────────────────────────
  var BN = null;
  try {
    var el = document.getElementById('bn-gift-config');
    if (el) {
      var c = JSON.parse(el.textContent);
      if (c && c.enabled) {
        var tiers = (c.tiers || []).filter(function (t) { return t && t.productId; });
        if (tiers.length) {
          var giftProducts = {};
          tiers.forEach(function (t) { giftProducts[t.productId] = true; });
          BN = {
            property: c.property, value: c.propertyValue,
            excluded: c.excludedTypes || [],
            minTier: Math.min.apply(null, tiers.map(function (t) { return t.min; })),
            giftProducts: giftProducts
          };
        }
      }
    }
  } catch (e) { console.warn(LOG, 'bn config', e); }
 
  // ─── Configuración (token público de la Storefront API) ─────────────
  var CONF = {};
  try { var ce = document.getElementById('tf-disc-config'); if (ce) CONF = JSON.parse(ce.textContent) || {}; } catch (e) {}
  var SF_VERSION = CONF.apiVersion || '2026-10';
 
  // Motivos de Shopify → estado para el pedido y mensaje para el cliente.
  var REASONS = {
    DISCOUNT_NOT_FOUND:                  { kind: 'invalid' },
    DISCOUNT_CURRENTLY_INACTIVE:         { kind: 'invalid' },
    DISCOUNT_NO_ENTITLED_SHIPPING_LINES: { kind: 'shipping' },
    DISCOUNT_NO_ENTITLED_LINE_ITEMS:     { kind: 'na', label: 'productos no incluidos', msg: 'no se aplica a los productos de tu carrito' },
    DISCOUNT_PURCHASE_NOT_IN_RANGE:      { kind: 'na', label: 'pedido mínimo no alcanzado', msg: 'requiere un importe mínimo que tu pedido no alcanza' },
    DISCOUNT_QUANTITY_NOT_IN_RANGE:      { kind: 'na', label: 'cantidad mínima no alcanzada', msg: 'requiere una cantidad mínima de productos' },
    DISCOUNT_USAGE_LIMIT_REACHED:        { kind: 'na', label: 'límite de usos alcanzado', msg: 'ya ha alcanzado su límite de usos' },
    DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED: { kind: 'na', label: 'límite de usos del cliente alcanzado', msg: 'ya lo has usado el máximo de veces permitido' },
    DISCOUNT_CUSTOMER_NOT_ELIGIBLE:      { kind: 'na', label: 'cliente no autorizado', msg: 'es solo para clientes concretos' },
    DISCOUNT_ELIGIBLE_CUSTOMER_MISSING:  { kind: 'na', label: 'cliente no autorizado', msg: 'es solo para clientes concretos: inicia sesión con tu cuenta para usarlo' },
    DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE: { kind: 'na', label: 'tipo de compra no compatible', msg: 'no es compatible con este tipo de compra' },
    DISCOUNT_CODE_NOT_HONOURED:          { kind: 'na', label: 'no acumulable con otro descuento', msg: 'no es acumulable con otro descuento de tu carrito' }
  };
 
  // Pregunta a la Storefront API por qué no se aplica el código (aplicándolo sobre el mismo carrito).
  async function classify(code, cart) {
    if (!CONF.sfToken || !cart || !cart.token) return { kind: 'unknown' };
    try {
      var r = await doFetch('/api/' + SF_VERSION + '/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Shopify-Storefront-Access-Token': CONF.sfToken },
        body: JSON.stringify({
          query: 'mutation($id:ID!,$codes:[String!]!){cartDiscountCodesUpdate(cartId:$id,discountCodes:$codes){cart{discountCodes{code applicable}} warnings{code} userErrors{code message}}}',
          variables: { id: 'gid://shopify/Cart/' + cart.token, codes: [code] }
        })
      });
      var j = await r.json();
      var p = j && j.data && j.data.cartDiscountCodesUpdate;
      if (!p) { console.warn(LOG, 'storefront', j && j.errors); return { kind: 'unknown' }; }
      var hit = ((p.cart && p.cart.discountCodes) || []).filter(function (d) { return sameCode(d.code, code); })[0];
      if (hit && hit.applicable) return { kind: 'applied' };
      var w = (p.warnings || []).map(function (x) { return x.code; }).filter(function (c) { return REASONS[c]; });
      // El más concreto primero: no encontrado/inactivo, luego envío, luego el resto.
      var order = ['DISCOUNT_NOT_FOUND', 'DISCOUNT_CURRENTLY_INACTIVE', 'DISCOUNT_NO_ENTITLED_SHIPPING_LINES'];
      w.sort(function (a, b) { var ia = order.indexOf(a), ib = order.indexOf(b); return (ia < 0 ? 9 : ia) - (ib < 0 ? 9 : ib); });
      if (!w.length) return { kind: 'unknown' };
      var info = REASONS[w[0]]; return { kind: info.kind, label: info.label, msg: info.msg, code: w[0] };
    } catch (e) {
      console.warn(LOG, 'classify failed', e);
      return { kind: 'unknown' };
    }
  }
 
  // ─── Registro «Código intentado» (atributo del carrito → pedido) ─────
  var ATTR = 'Código intentado';
  var SEP = ' | ', DASH = ' — ';
  function readAttempts(cart) {
    var raw = cart && cart.attributes && cart.attributes[ATTR];
    var list = [];
    String(raw || '').split(SEP).forEach(function (part) {
      var i = part.indexOf(DASH); if (i < 1) return;
      list.push({ code: part.slice(0, i).trim(), status: part.slice(i + DASH.length).trim() });
    });
    return list;
  }
  function statusOf(cart, code) {
    var e = readAttempts(cart).filter(function (x) { return sameCode(x.code, code); })[0];
    return e ? e.status : '';
  }
  async function record(code, status) {
    try {
      var cart = lastCart || await getCart();
      var list = readAttempts(cart).filter(function (x) { return !sameCode(x.code, code); });
      list.push({ code: String(code).trim().toUpperCase(), status: status });
      var value = list.map(function (x) { return x.code + DASH + x.status; }).join(SEP);
      var attrs = {}; attrs[ATTR] = value;
      var r = await doFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ attributes: attrs }) });
      if (r.ok) lastCart = await r.json();
    } catch (e) { console.warn(LOG, 'record failed', e); }
  }
  var ST = {
    APPLIED: 'APLICADO',
    REMOVED: 'APLICADO Y QUITADO DESPUÉS',
    GIFT: 'ELIGIÓ EL REGALO (NO APLICADO)',
    INVALID: 'NO VÁLIDO',
    NA: 'NO APLICABLE',
    SHIPPING: 'ENVÍO GRATIS (SE APLICA EN EL PAGO)',
    UNKNOWN: 'NO APLICADO'
  };
 
  function isGift(it) {
    if (!BN) return false;
    return !!(BN.giftProducts[it.product_id] || (it.properties && it.properties[BN.property] === BN.value));
  }
  function bnState(cart) {
    if (!BN) return { gift: null, inPlay: false };
    var total = 0, gift = null;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) { gift = gift || it; return; }
      if (it.gift_card || BN.excluded.indexOf(it.product_type) !== -1) return;
      total += it.original_line_price != null ? it.original_line_price : it.line_price;
    });
    return { gift: gift, inPlay: !!gift || total >= BN.minTier };
  }
 
  // ─── Carrito ────────────────────────────────────────────────────────
  var lastCart = null;
  function getCart() {
    return doFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }
  function setDiscount(code) {
    return doFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ discount: code }) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  // El carrito de Shopify tarda un momento en reflejar los cambios de código: esperamos a que /cart.js
  // muestre el estado esperado antes de repintar (máx. ~4 s).
  async function settle(pred) {
    for (var i = 0; i < 10; i++) {
      try { var c = await getCart(); if (pred(c)) return c; } catch (e) {}
      await new Promise(function (r) { setTimeout(r, 400); });
    }
    return lastCart;
  }
  function codesOf(cart) { return (cart && cart.discount_codes) || []; }
  // ¿Alguna línea sigue llevando descuento de código? (Shopify a veces devuelve primero el código quitado
  // y un instante después los precios recalculados.)
  function hasCodeAllocations(cart) {
    return ((cart && cart.items) || []).some(function (it) {
      return (it.line_level_discount_allocations || []).some(function (a) {
        return a && a.discount_application && a.discount_application.type === 'discount_code';
      });
    });
  }
  function sameCode(a, b) { return String(a).trim().toLowerCase() === String(b).trim().toLowerCase(); }
 
  var isCartPage = function () { return /\/cart\/?$/.test(window.location.pathname); };
  var MSG_KEY = 'tf_disc_msg';
  function refreshCart() {
    if (isCartPage()) {
      // La página del carrito se recarga: guardamos el mensaje para enseñarlo después.
      try { sessionStorage.setItem(MSG_KEY, JSON.stringify({ msg: ui.page.msg, type: ui.page.msgType, point: !!ui.page.pointGift, t: Date.now() })); } catch (e) {}
      window.location.reload();
      return new Promise(function () {});
    }
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.getSectionsToRender !== 'function' || typeof cd.renderContents !== 'function') {
      return getCart().then(render);
    }
    var sections = cd.getSectionsToRender().map(function (s) { return s.section; }).join(',');
    return doFetch('/cart/update.js', {
      method: 'POST', headers: JSON_HEADERS,
      body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      cd.renderContents(state, cd.classList.contains('is-visible'));
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
      if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
      return getCart().then(render);
    }).catch(function (e) { console.warn(LOG, 'refresh failed', e); return getCart().then(render); });
  }
 
  // ─── Interfaz ───────────────────────────────────────────────────────
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  };
 
  var CSS =
    '.tf-disc{margin:0 0 14px;font-size:14px;line-height:1.4}' +
    '.tf-disc__toggle{background:none;border:0;padding:0;font:inherit;font-weight:600;text-decoration:underline;cursor:pointer;color:inherit}' +
    '.tf-disc__row{display:flex;gap:8px;margin-top:8px}' +
    '.tf-disc__input{flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid #c9c5bf;border-radius:4px;font:inherit;text-transform:uppercase;background:#fff;color:#0a0a0a}' +
    '.tf-disc__input:focus{outline:2px solid #0a0a0a;outline-offset:1px}' +
    '.tf-disc__btn{height:44px;padding:0 16px;border:1px solid #0a0a0a;border-radius:4px;background:#0a0a0a;color:#fff;font:inherit;font-weight:600;cursor:pointer;white-space:nowrap}' +
    '.tf-disc__btn--ghost{background:#fff;color:#0a0a0a}' +
    '.tf-disc__btn:disabled,.tf-disc.is-busy .tf-disc__btn{opacity:.55;cursor:default}' +
    '.tf-disc__applied{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;border:1px dashed #0a0a0a;border-radius:4px}' +
    '.tf-disc__link{background:none;border:0;padding:0;font:inherit;text-decoration:underline;cursor:pointer;color:inherit}' +
    '.tf-disc__warn{margin-top:10px;padding:12px;border-radius:4px;background:#fff4ec;border:1px solid #F5500D}' +
    '.tf-disc__warn p{margin:0 0 10px}' +
    '.tf-disc__warn .tf-disc__row{flex-wrap:wrap;margin-top:0}' +
    '.tf-disc__warn .tf-disc__btn{flex:1 1 auto}' +
    '.tf-disc__msg{margin:8px 0 0;font-size:13px}' +
    '.tf-disc__msg--error{color:#b42318}' +
    '.tf-disc__msg--ok{color:#1a7f37}' +
    '.tf-disc__msg--warn{padding:10px 12px;border-radius:4px;background:#F5500D;color:#fff;font-weight:600;font-size:14px}' +
    '@keyframes tfGiftPulse{0%,100%{box-shadow:0 0 0 0 rgba(245,80,13,0)}50%{box-shadow:0 0 0 4px rgba(245,80,13,.9)}}' +
    '.tf-gift-pulse{animation:tfGiftPulse 1s ease-in-out 4}';
  function injectCss() {
    if (document.getElementById('tf-disc-css')) return;
    var s = document.createElement('style'); s.id = 'tf-disc-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }
 
  // Estado por contexto (drawer / page) para que no se pierda al repintar.
  var ui = { drawer: { open: false, value: '', warn: false, msg: '', msgType: '' },
             page: { open: false, value: '', warn: false, msg: '', msgType: '' } };
 
  function html(ctx) {
    var st = ui[ctx];
    // Códigos que ya hemos rechazado (no válido / no aplicable) no se enseñan aunque el carrito tarde en limpiarlos.
    var codes = codesOf(lastCart).filter(function (d) {
      var stt = statusOf(lastCart, d.code);
      return d.applicable || !(stt === ST.INVALID || stt.indexOf(ST.NA) === 0 || stt === ST.UNKNOWN);
    });
    var msg = st.msg ? '<p class="tf-disc__msg tf-disc__msg--' + st.msgType + '" role="status">' + esc(st.msg) + '</p>' : '';
    if (codes.length) {
      var c = codes[0];
      var shipping = statusOf(lastCart, c.code) === ST.SHIPPING;
      return '<div class="tf-disc__applied"><span>Código <strong>' + esc(c.code.toUpperCase()) + '</strong> ' +
        (c.applicable ? 'aplicado' : shipping ? 'guardado: se aplica en la página de pago' : '<em>no aplicable a este carrito</em>') + '</span>' +
        '<button type="button" class="tf-disc__link" data-tf-disc-remove>Quitar</button></div>' + msg;
    }
    if (!st.open) {
      return '<button type="button" class="tf-disc__toggle" data-tf-disc-toggle aria-expanded="false">¿Tienes un código de descuento?</button>' + msg;
    }
    var id = 'tf-disc-input-' + ctx;
    var out = '<label class="tf-disc__toggle" for="' + id + '" style="text-decoration:none;cursor:default">Código de descuento</label>' +
      '<div class="tf-disc__row"><input class="tf-disc__input" id="' + id + '" data-tf-disc-input type="text" ' +
      'autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Introduce tu código" value="' + esc(st.value) + '">' +
      '<button type="button" class="tf-disc__btn" data-tf-disc-apply>Aplicar</button></div>';
    if (st.warn) {
      out += '<div class="tf-disc__warn" role="alert"><p>El guante de regalo de Black November <strong>no es acumulable con códigos de descuento</strong>. ' +
        'Si aplicas el código, te quedas sin el regalo.</p><div class="tf-disc__row">' +
        '<button type="button" class="tf-disc__btn" data-tf-disc-confirm>Usar mi código (sin regalo)</button>' +
        '<button type="button" class="tf-disc__btn tf-disc__btn--ghost" data-tf-disc-keep>Prefiero el regalo</button></div></div>';
    }
    return out + msg;
  }
 
  function targets() {
    var list = [];
    var d = document.querySelector('#CartDrawer-FormSummary #cart-summary');
    if (d) list.push({ ctx: 'drawer', parent: d, before: d.querySelector('.cart-drawer__summary-actions') });
    var p = document.querySelector('.cart__summary#cart-summary');
    if (p && !p.closest('cart-drawer')) list.push({ ctx: 'page', parent: p, before: p.querySelector('.cart__summary-actions') });
    return list;
  }
 
  var rendering = false;
  function render() {
    if (!lastCart) return;
    rendering = true;
    try {
      targets().forEach(function (t) {
        var box = t.parent.querySelector(':scope > [data-tf-disc]');
        if (!lastCart.item_count) { if (box) box.remove(); return; }
        if (!box) {
          box = document.createElement('div');
          box.setAttribute('data-tf-disc', t.ctx);
          box.className = 'tf-disc';
          t.parent.insertBefore(box, t.before || null);
        }
        var h = html(t.ctx);
        if (box.__h !== h) {
          var focused = document.activeElement && box.contains(document.activeElement) && document.activeElement.matches('[data-tf-disc-input]');
          box.innerHTML = h; box.__h = h;
          if (focused) { var inp = box.querySelector('[data-tf-disc-input]'); if (inp) { inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length); } }
        }
      });
    } finally { rendering = false; }
  }
 
  // El tema repinta el carrito → reinsertar el campo.
  var moTimer = null;
  var pulseUntil = 0;
  new MutationObserver(function () {
    if (Date.now() < pulseUntil) {
      document.querySelectorAll('[data-bn-gift]:not(.tf-gift-pulse)').forEach(function (b) { b.classList.add('tf-gift-pulse'); });
    }
    if (rendering || moTimer) return;
    moTimer = setTimeout(function () {
      moTimer = null;
      var missing = targets().some(function (t) { return !t.parent.querySelector(':scope > [data-tf-disc]'); });
      if (missing) getCart().then(render).catch(function () {});
    }, 80);
  }).observe(document.body, { childList: true, subtree: true });
 
  // ─── Acciones ───────────────────────────────────────────────────────
  function setMsg(ctx, msg, type) { ui[ctx].msg = msg || ''; ui[ctx].msgType = type || ''; }
  function busy(ctx, on) {
    document.querySelectorAll('[data-tf-disc="' + ctx + '"]').forEach(function (b) {
      b.classList.toggle('is-busy', on);
      b.querySelectorAll('button, input').forEach(function (x) { x.disabled = on; });
    });
  }
 
  async function apply(ctx, confirmed) {
    var st = ui[ctx];
    var code = (st.value || '').trim();
    if (!code) { setMsg(ctx, 'Escribe tu código de descuento.', 'error'); render(); return; }
    setMsg(ctx, '');
    busy(ctx, true);
    var removedGift = null;
    try {
      var cart = await getCart();
      var bn = bnState(cart);
      if (bn.inPlay && !confirmed) { st.warn = true; busy(ctx, false); render(); return; }
      st.warn = false;
 
      if (bn.gift) {
        removedGift = { id: bn.gift.variant_id, properties: bn.gift.properties || {} };
        await doFetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: bn.gift.key, quantity: 0 }) });
      }
 
      var after = await setDiscount(code);
      var hit = codesOf(after).filter(function (d) { return sameCode(d.code, code); })[0];
 
      var info = (hit && hit.applicable) ? { kind: 'applied' } : await classify(code, after);
      var CODE = code.toUpperCase();
 
      if (info.kind === 'applied' || info.kind === 'shipping') {
        if (info.kind === 'shipping') await setDiscount(code); // que quede guardado tal cual en el carrito
        st.value = ''; st.open = false;
        await record(code, info.kind === 'shipping' ? ST.SHIPPING : ST.APPLIED);
        var okMsg = info.kind === 'shipping' ? 'Código de envío gratis guardado: el descuento se aplica en la página de pago.' : 'Código aplicado.';
        setMsg(ctx, okMsg + (removedGift ? ' Hemos quitado el guante de regalo del carrito.' : ''), 'ok');
        await settle(function (c) { return codesOf(c).some(function (d) { return sameCode(d.code, code); }) && !bnState(c).gift; });
      } else {
        await setDiscount('');
        if (removedGift) {
          await doFetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS,
            body: JSON.stringify({ items: [{ id: removedGift.id, quantity: 1, properties: removedGift.properties }] }) });
        }
        var text;
        if (info.kind === 'invalid') {
          await record(code, ST.INVALID);
          text = 'El código «' + CODE + '» no existe o ya no está activo.';
        } else if (info.kind === 'na') {
          await record(code, ST.NA + ' (' + info.label + ')');
          text = 'El código «' + CODE + '» ' + info.msg + '.';
        } else {
          await record(code, ST.UNKNOWN);
          text = 'El código «' + CODE + '» no es válido o no se puede aplicar a este carrito.';
        }
        setMsg(ctx, text + (removedGift ? ' Mantienes tu guante de regalo.' : ''), 'error');
        await settle(function (c) { return !codesOf(c).length && (!removedGift || !!bnState(c).gift); });
      }
    } catch (e) {
      console.warn(LOG, 'apply failed', e);
      setMsg(ctx, 'No hemos podido aplicar el código. Inténtalo de nuevo o introdúcelo en la página de pago.', 'error');
    }
    await refreshCart();
    busy(ctx, false);
    render();
  }
 
  async function removeCode(ctx) {
    busy(ctx, true);
    try {
      var current = codesOf(lastCart || await getCart());
      await setDiscount('');
      for (var k = 0; k < current.length; k++) {
        var was = statusOf(lastCart, current[k].code);
        if (!was || was === ST.APPLIED || was === ST.SHIPPING) await record(current[k].code, ST.REMOVED);
      }
      var after = await settle(function (c) { return !codesOf(c).length && !hasCodeAllocations(c); });
      var st = bnState(after || {});
      if (BN && st.inPlay && !st.gift) {
        setMsg(ctx, 'Código quitado. Vuelve a seleccionar tu guante de regalo.', 'warn');
        ui[ctx].pointGift = true;
      } else {
        setMsg(ctx, 'Código quitado.', 'ok');
      }
    } catch (e) {
      console.warn(LOG, 'remove failed', e);
      setMsg(ctx, 'No hemos podido quitar el código. Inténtalo de nuevo.', 'error');
    }
    await refreshCart();
    busy(ctx, false);
    render();
    // Segundo repintado al poco: asegura que los precios del carrito lateral ya salen sin el código.
    setTimeout(function () {
      refreshCart().then(function () {
        if (ui[ctx].pointGift) { ui[ctx].pointGift = false; pointToGift(ctx); }
      });
    }, 1200);
  }
 
  // Lleva al cliente al bloque del regalo de Black November y lo resalta unos segundos.
  function pointToGift(ctx, tries) {
    tries = tries || 0;
    var scope = ctx === 'drawer' ? document.querySelector('#CartDrawer-Body') : document.querySelector('#main-cart-items');
    var box = scope && scope.querySelector('[data-bn-gift]');
    if (!box) { if (tries < 20) setTimeout(function () { pointToGift(ctx, tries + 1); }, 250); return; }
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
    pulseUntil = Date.now() + 4000;
    box.classList.add('tf-gift-pulse');
    setTimeout(function () {
      document.querySelectorAll('.tf-gift-pulse').forEach(function (b) { b.classList.remove('tf-gift-pulse'); });
    }, 4100);
  }
 
  function ctxOf(node) { var b = node.closest('[data-tf-disc]'); return b && b.getAttribute('data-tf-disc'); }
 
  // Fase de captura + stopPropagation: el repintado deja el botón fuera del DOM y el carrito lateral
  // interpretaría el clic como «clic fuera» y se cerraría.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-tf-disc-toggle],[data-tf-disc-apply],[data-tf-disc-confirm],[data-tf-disc-keep],[data-tf-disc-remove]');
    if (!t) return;
    var ctx = ctxOf(t); if (!ctx) return;
    e.preventDefault(); e.stopPropagation();
    var st = ui[ctx];
    if (t.hasAttribute('data-tf-disc-toggle')) {
      st.open = true; setMsg(ctx, ''); render();
      var inp = document.querySelector('[data-tf-disc="' + ctx + '"] [data-tf-disc-input]'); if (inp) inp.focus();
    } else if (t.hasAttribute('data-tf-disc-apply')) {
      apply(ctx, false);
    } else if (t.hasAttribute('data-tf-disc-confirm')) {
      apply(ctx, true);
    } else if (t.hasAttribute('data-tf-disc-keep')) {
      var kept = (st.value || '').trim();
      st.warn = false; st.value = ''; st.open = false; setMsg(ctx, 'Perfecto, mantienes el guante de regalo.', 'ok'); render();
      if (kept) record(kept, ST.GIFT);
    } else if (t.hasAttribute('data-tf-disc-remove')) {
      removeCode(ctx);
    }
  }, true);
 
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-tf-disc-input]')) return;
    var ctx = ctxOf(e.target); if (!ctx) return;
    ui[ctx].value = e.target.value; ui[ctx].warn = false;
  });
 
  // Enter dentro del campo: aplicar, sin enviar el formulario del carrito.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-tf-disc-input]')) return;
    var ctx = ctxOf(e.target); if (!ctx) return;
    e.preventDefault(); e.stopPropagation();
    ui[ctx].value = e.target.value;
    apply(ctx, false);
  }, true);
 
  // Cambios del carrito hechos por el tema u otros scripts → repintar el estado del código.
  var refreshTimer = null;
  var prevFetch = window.fetch;
  window.fetch = function (input) {
    var p = prevFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(function () { getCart().then(render).catch(function () {}); }, 900);
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
 
  // ─── Arranque ───────────────────────────────────────────────────────
  function start() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(MSG_KEY) || 'null');
      sessionStorage.removeItem(MSG_KEY);
      if (saved && saved.msg && Date.now() - saved.t < 30000) {
        ui.page.msg = saved.msg; ui.page.msgType = saved.type;
        if (saved.point) setTimeout(function () { pointToGift('page'); }, 600);
      }
    } catch (e) {}
    injectCss(); getCart().then(render).catch(function (e) { console.warn(LOG, 'init failed', e); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();